import { IncomeAmountAmountType } from "Infrastructure/ApiZfp/Schema";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, number, object, string } from "yup";

export type DisabilityIncomeFormType = {
  readonly degree:
    | typeof IncomeAmountAmountType.first_degree_disability
    | typeof IncomeAmountAmountType.second_degree_disability
    | typeof IncomeAmountAmountType.third_degree_disability;
  readonly amountValueFirstDegree?: number;
  readonly amountValueSecondDegree?: number;
  readonly amountValueThirdDegree?: number;
};

export const getDisabilityIncomeFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<DisabilityIncomeFormType> = (t) => {
  const createConditionalSchema = (degree: IncomeAmountAmountType) => {
    return number()
      .transform((value, original) => (original === "" ? undefined : value))
      .when("degree", ([degreeValue], schema) => {
        if (degreeValue === degree) {
          return schema
            .required(t(Resources.Validation.Required))
            .min(1, t(Resources.Validation.Number.MoreThen, { count: 0 }))
            .typeError(t(Resources.Validation.Required));
        }
        return schema.default(0); // pokud není tento degree vybrán, dáme 0
      });
  };

  return object({
    degree: string()
      .oneOf([
        IncomeAmountAmountType.first_degree_disability,
        IncomeAmountAmountType.second_degree_disability,
        IncomeAmountAmountType.third_degree_disability,
      ])
      .required(t(Resources.Validation.Required)),
    amountValueFirstDegree: createConditionalSchema(IncomeAmountAmountType.first_degree_disability),
    amountValueSecondDegree: createConditionalSchema(IncomeAmountAmountType.second_degree_disability),
    amountValueThirdDegree: createConditionalSchema(IncomeAmountAmountType.third_degree_disability),
  }).defined();
};
